/**
 * Welche Meinungsthemen in der laufenden Partie zählen.
 * Version 1 und 2: die bisherigen 18 Themen. Ab Version 3 zusätzlich „Gesellschaft und Werte“.
 * Alle Berechnungen, die über Themen laufen, nutzen axes(), damit ältere Partien unverändert bleiben.
 */
import { AX } from '../content/axes';
import { AX3 } from '../content/axes3';
import { since } from './version';
import { ISSUES } from '../content/issues';
import { ISSUES3 } from '../content/issues3';
import '../content/agenda3';

const ISS_BASE: any[] = [...ISSUES];
const ISS_ALL: any[] = [...ISSUES, ...ISSUES3];
/** Probleme der laufenden Partie. Version 1 und 2: die bisherigen. Ab Version 3 zusätzlich die neuen. */
export const issuesNow = (): any[] => (since(3) ? ISS_ALL : ISS_BASE);
/** Alle Probleme, die es gibt (für Daten, nie für Berechnungen). */
export const allIssues = (): any[] => ISS_ALL;

const BASE: string[] = [...AX];
const ALL: string[] = [...AX, ...AX3];

/** Themen der laufenden Partie. */
export const axes = (): string[] => (since(3) ? ALL : BASE);
/** Alle Themen, die es gibt (für Daten wie Positionen, nie für Berechnungen). */
export const allAxes = (): string[] => ALL;
/** Gehört das Thema zu „Gesellschaft und Werte“? */
export const isV3Axis = (a: string) => AX3.includes(a);
